import { z } from "zod";

export const contactFormSchema = z.object({
	name: z
		.string()
		.trim()
		.min(2, "Name must be at least 2 characters")
		.max(100, "Name must be less than 100 characters"),
	email: z
		.email("Please enter a valid email address")
		.trim()
		.toLowerCase()
		.min(1, "Email is required")
		.max(254, "Email address is too long"),
	phone: z
		.string()
		.trim()
		.max(30, "Phone number is too long")
		.regex(
			/^$|^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
			"Please enter a valid phone number",
		)
		.optional()
		.or(z.literal("")),
	subject: z
		.string()
		.trim()
		.min(1, "Please select a subject")
		.max(200, "Subject is too long"),
	message: z
		.string()
		.trim()
		.min(10, "Message must be at least 10 characters")
		.max(5000, "Message must be less than 5000 characters"),
	newsletter: z.boolean().default(false),
	// Honeypot anti-spam field. Real users never fill it (hidden input);
	// bots typically do. Checked server-side before anything else.
	website: z.string().trim().max(200).optional().default(""),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
